import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const IMAGES = {
  "renovation-complete": "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/bef13f1daac35a77b0153bac43c927e36792ce732857819bd0c65d07f4fbcaf3.png",
  "renovation-cuisine": "https://images.pexels.com/photos/29412579/pexels-photo-29412579.jpeg",
  "renovation-salle-de-bain": "https://images.pexels.com/photos/34787744/pexels-photo-34787744.jpeg",
  "peinture-decoration": "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/ec81571e1805db7f10ea0b003663abee06a6d7bd6c67c1bec0309500e16f7218.png",
  "electricite": "https://images.pexels.com/photos/28536630/pexels-photo-28536630.jpeg",
  "plomberie": "https://images.pexels.com/photos/19786084/pexels-photo-19786084.jpeg",
};

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" data-testid="services-section" className="section bg-ivory">
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8 mb-16 items-end">
          <div className="col-span-12 md:col-span-7">
            <p className="overline">— Services</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-6">
              Six métiers,<br />
              un seul interlocuteur.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-12">
            <p className="text-ink/70 text-lg leading-relaxed">
              Que vous rénoviez l'intégralité d'un haussmannien ou une simple salle de bain, notre atelier coordonne l'ensemble des corps d'état avec exigence et clarté.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line">
          {services.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="bg-bone p-8 md:p-10 group hover:bg-ink hover:text-bone transition-colors duration-500 relative"
              data-testid={`service-card-${s.slug}`}
            >
              <div className="aspect-[5/3] overflow-hidden mb-6">
                <img
                  src={IMAGES[s.slug]}
                  alt={s.title}
                  className="w-full h-full object-cover img-zoom"
                  loading="lazy"
                />
              </div>
              <div className="flex items-start justify-between gap-4">
                <span className="overline opacity-60">0{i + 1}</span>
                <ArrowUpRight className="w-5 h-5 opacity-40 group-hover:opacity-100 transition-opacity" />
              </div>
              <h3 className="font-display text-3xl md:text-4xl mt-3 leading-tight">{s.title}</h3>
              <p className="mt-3 text-base leading-relaxed opacity-80">{s.tagline}</p>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-link-${s.slug}`}
                className="mt-6 inline-block overline link-arc"
              >
                Découvrir
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
